export default {
  title: 'Invoice Registry',
  notFound: 'Page nog found',
  user: {
    username: 'Username',
    password: 'Password',
    confirmPassword: 'Confirm password',
    email: 'E-mail',
    firstTimeLogin: 'First time login',
    passwordForgotten: 'Forgot password?',
    passwordResetLinkSent: 'Password reset link has been sent to your email address'
  },
  general: {
    phone: 'Phone',
    email: 'E-mail',
    changelog: 'Changelog',
    technicalSupport: 'Technical support'
  },
  forms: {
    ok: 'OK',
    cancel: 'Cancel',
    submit: 'Submit',
    send: 'Send',
    close: 'Close',
    save: 'Save',
    apply: 'Apply',
    edit: 'Edit',
    warning: 'Warning',
    notification: 'Notification',
    load: 'Load',
    saveToFile: 'Save to file',
    saveToDiagnosticFile: 'Save to diagnostics file',
    saveToClipboard: 'Save to clipboard',
    capsLockOn: 'Capslock is on'
  },
  dashboard: {
    welcome: 'Welcome',
    liabilitiesRegisteredTotal: 'No. of invoices registred today',
    liabilitiesRegisteredDebtor: 'As debtor',
    liabilitiesRegisteredCreditor: 'As creditor',
    liabilitiesRegistrationLimit: 'Monthly limit to number of registered invoices'
  },
  sidebar: {
    allInvoices: 'All invoices',
    registerInvoice: 'Register invoice',
    userAdministration: 'User administration',
    userRegistration: 'User registration',
    reportedIssues: 'Issues',
    groupSettlement: 'Group Settlement',
    invoiceSettlement: 'Invoice settlement'
  },
  activation: {
    title: 'User activation',
    success: 'User successfully activated',
    activationSent: 'User activation link has been sent to your email address'
  },
  reset: {
    title: 'Password change',
    success: 'User password set succesfully'
  },
  issues: {
    reportIssue: 'Report an issue',
    reportIssueDetails: 'Issue details',
    reportIssueSuccess: 'Issue reported succesfully',
    reportIssueLiability: 'Invoice registration issue',
    reportIssueSettlement: 'Issue with invoice settlement',
    reportId: 'Id',
    reportSettlementId: 'Settlement Id',
    reportCategories: 'Issue category',
    reportData: 'Additional information',
    reportSettlementAmount: 'Settlement amount',
    reportUserComment: 'User comment',
    reportOperatorComment: 'Operator comment',
    reportColumnCategory: 'Category',
    reportColumnCreationDate: 'Creation Date',
    reportColumnClosingDate: 'Closing date',
    reportColumnData: 'Data',
    reportColumnResourceId: 'ResourceID',
    reportColumnStatus: 'Status',
    reportColumnCompanyNumber: 'Budget Number',
    reportIssueStatus: {
      0: 'All',
      1: 'Active',
      2: 'Canceled',
      3: 'Resolved',
      4: 'Unresolved'
    },
    reportIssueCancel: 'Cancel issue',
    reportIssueResolve: 'Resolve issue',
    reportIssueCancelModal: 'Issue cancel',
    reportIssueCancelModalConfirm: 'Do you want to cancel the issue',
    reportIssueCancelSuccess: 'Issue succesfully canceled',
    reportIssueResolveModal: 'Resolve issue',
    reportIssueResolveSuccess: 'Issue sucessfully resolved',
    reportIssueResolved: 'Mark resolved',
    reportIssueUnresolved: 'Mark as unresolved',
    reportIssueResolveComment: 'Resolve comment',
    reportIssueUserLogin: 'User login',
    reportIssueUserName: 'First and last name',
    reportIssueUserOrganization: 'Organisation',
    reportIssueBank: 'Bank',
    reportIssueBankFeedback: 'Bank has to contain 3 characters',
    reportIssueHelpLink: 'Detialed instructions',
    reportIssues: 'Issues',
    reportIssuesActive: 'Active',
    reportIssuesAll: 'All'
  },
  register: {
    title: 'Registration',
    registrationForbidden: 'Registration not allowed',
    legalEntityInfo: 'Legal entity info',
    legalEntityCheckboxText: 'I\'m legal entity',
    budgetIdNumber: 'Budget ID number',
    budgetIdNumberFootnote: 'Budget ID footnote',
    companyNumber: 'Company number',
    companyNumberShort: 'CRN',
    taxIdNumber: 'Tax ID number',
    parentCompany: 'Parent company',
    companyName: 'Company name',
    legalEntityName: 'Legal entity name',
    address: 'Company address',
    postalCode: 'Postal code',
    treasuryBranch: 'Treasury branch',
    treasuryBranchInfo: 'Treasury branch info',
    treasuryBranchNote: 'Type first several letters of a city/region and system will offer the list',
    email: 'Company e-mail',
    adminInfo: 'Admin info',
    name: 'Name and last name',
    personalIdentityNumber: 'Personal identity number',
    identityNumber: 'Identity number',
    submit: 'Send registration request',
    infoText: 'After successfully completing the request, you will receive an e-mail with details of the registration steps.',
    registrationSuccess: 'Registration succesfull',
    registrationSuccessText: 'Verify that you have received confirmation email from Treasury. Otherwise save your registration form by clicking on \'Print form\'',
    registrationLimitExceeded: 'Registration request limit exceeded',
    printRequestForm: 'Print form',
    printForm: 'Print form',
    ouList: 'List of organizational units',
    editRegistration: 'To edit registration click on Edit registration',
    editRegistrationLine2: 'After you input the changes, save them by pressing the button \'Send registration request\'',
    editRegistrationButton: 'Edit registration',
    editRegistrationToken: 'Edit registration token',
    editRegistrationLoad: 'Load registration data',
    registrationLoad: 'Load registration'
  },
  invoices: {
    invoiceIndex: 'Invoice index - ',
    invoiceReview: 'Review invoices',
    review: 'Review',
    invoiceDetails: 'Invoice details',
    invoiceId: 'Invoice ID',
    settlementDetails: 'Invoice settlements details',
    cancelInvoice: 'Cancel invoice',
    cancelInvoices: 'Cancel invoices',
    cancellationUser: 'Cancellation user',
    cancellationDate: 'Cancellation date',
    cancellationComment: 'Cancellation comment',
    cancellationSuccess: 'Invoices cancelled',
    columnCreditor: 'Creditor',
    columnDebtor: 'Debtor',
    columnId: 'ID',
    columnBudgetIdNumber: 'Budget ID',
    columnInvoiceNumber: 'Invoice number',
    columnInvoiceAmount: 'Amount',
    columnInvoiceAmountFrom: 'From',
    columnInvoiceAmountTo: 'To',
    columnSelected: 'Selected',
    columnSettlementAmount: 'Settlement amount',
    columnSettlementDate: 'Settlement date',
    columnInvoiceStatus: 'Status',
    columnCreditorName: 'Creditor name',
    columnDebtorName: 'Debtor name',
    columnCreditorBudgetIdNumber: 'Budget ID',
    columnCreditorTaxId: 'Creditor Tax ID',
    columnCreditorCompanyNumber: 'Creditor company number',
    columnDueDate: 'Due date',
    columnPreviousDueDate: 'Previous due date',
    columnDueDateRangeFrom: 'Due date from',
    columnDueDateRangeTo: 'Due date to',
    columnCreationDate: 'Creation date',
    columnCreationDateRangeFrom: 'From',
    columnCreationDateRangeTo: 'To',
    columnLifetime: 'Lifetime',
    columnSettlementComments: 'Settlement comments',
    columnSettlementStatus: 'Status',
    columnSettledAmount: 'Settled amount',
    invoiceRegistered: 'Invoice succesfully registered',
    invoicesRegistered: 'Payload of invoices sucesfully registered',
    invoicesPartiallyRegistered: 'Payload of invoices partially registered',
    invoiceExport: 'Export',
    invoiceCancelled: 'Cancelled',
    invoiceCancelFailed: 'Invoice cancellation failed',
    invoiceExportJson: 'Export to JSON',
    invoiceExportCsv: 'Export to CSV',
    invoiceExportFailed: 'Invoice export failed',
    invoiceSettled: 'Settled',
    invoiceStatus: {
      0: 'All',
      1: 'Active',
      2: 'Invalid',
      3: 'Cancelled',
      4: 'Partially Settled',
      5: 'Settled',
      6: 'Assigned',
      7: 'Proinvoice',
      101: 'Open'
    },
    settlementStatus: {
      1: 'Active',
      2: 'Cancelled'
    },
    invoiceLimitExceeded: 'Invoice registration request limit exceeded',
    invoiceCurrency: 'Din',
    invoicesAsDebtor: 'As debtor',
    invoicesAsCreditor: 'As creditor',
    invoicesAsAdministrator: 'As administrator',
    invoiceAssigned: 'Assigned',
    invoiceAssignedName: 'Assigned company name',
    invoiceAssignedBudgetNumber: 'Assigned Budget number',
    invoiceAssignedCompanyNumber: 'Assigned company number',
    invoiceAssignedTaxIdNumber: 'Assigned Tax ID number',
    invoiceAssignment: 'Assign invoice',
    invoiceAssignmentInformation: 'Assignement information',
    invoiceAssignmentContractNumber: 'Assignment contract number',
    invoiceAssignmentModal: 'Assign invoice?',
    invoiceAssignmentCancelModal: 'Cancel invoice assign?',
    invoiceAssignSuccess: 'Assign successful',
    invoiceAssignCancelSuccess: 'Assign cancel successful',
    invoiceAssignCancel: 'Cancel assign',
    invoiceAssignIdf: 'Assigned invoice ID',
    invoiceAssignOriginIdf: 'Assigned invoice ID',
    invoiceAssignValidDebtorWarning: 'Assignation can only be done by a local user that is an invoice debtor :',
    invoiceAmountChange: 'Amount change', // TODO check these
    invoiceAmountChangeAdd: 'Add change', // TODO check these
    invoiceAmountChangeSettle: 'Settle',
    invoiceAmountChangeSuccess: 'Amount change success',
    invoiceDeltaColumnAmount: 'Change amount',
    invoiceDeltaColumnComments: 'Change/cancellation comment',
    invoiceDeltaColumnDate: 'Cancellation/change date',
    invoiceDeltaCancel: 'Cancel change',
    invoiceActivationCancel: 'Cacel activation',
    invoiceNotFound: 'Requested invoice not found',
    invoiceCancelledComment: 'Cancelation comment:',
    expandSections: 'Expand all sextions',
    collapseSections: 'Collapse all sections'
  },
  registerInvoice: {
    invoice: 'Invoice',
    registerSingleInvoice: 'Single entry',
    registerMultipleInvoices: 'Multiple entries',
    invoiceFileInput: 'Choose multiple invoices file',
    invoiceFileBrowse: 'Browse',
    invoiceFileNoSelection: 'No files selected',
    invoiceRegistration: 'Invoice registration',
    debtorBudgetId: 'Debtor Budget ID',
    invoiceNumber: 'Invoice number',
    amount: 'Amount',
    issuePlace: 'Issue place',
    issueDate: 'Issue date',
    comments: 'Comments',
    registerInvoice: 'Register invoice',
    groupInvoiceRegistration: 'Group invoice registration',
    invoiceFileParse: 'Multiple invoice file read failed',
    registerInvoiceConfirmation: 'Register invoice?',
    registerMultipleErrorList: 'Register error list',
    registerMultipleSuccessList: 'List of registred invoices',
    registerMultipleCsvHeaderError: 'Missing or non valid header in CSV file',
    registerProinvoice: 'Proinvoice',
    registerProinvoiceLifetime: 'Lifetime in days',
    registerProinvoiceLifetimeEmpty: 'Lifetime must be between 1 and 90 days',
    registerProinvoiceFootnote: '*Default lifetime value will be used if none is selected'
  },
  groupSettlement: {
    groupSettlementReview: 'Review group settlements',
    columnGroupSettlementNumber: 'Specification #',
    columnCreditor: 'Creditor',
    columnAmount: 'Amount',
    columnAmountFrom: 'From',
    columnAmountTo: 'To',
    columnDebtor: 'Debtor',
    columnCreationDate: 'Creation date',
    columnCreationDateRangeFrom: 'From',
    columnCreationDateRangeTo: 'To',
    columnDueDate: 'Due date',
    columnDueDateRangeFrom: 'From',
    columnDueDateRangeTo: 'To',
    columnSettlementDate: 'Settlement date',
    columnSettlementDateRangeFrom: 'From',
    columnSettlementDateRangeTo: 'To',
    columnStatus: 'Status',
    columnInvoiceErrorCode: 'Status within group settlement',
    columnInvoiceCount: 'Number of invoices',
    groupSettlementCreator: 'Created by',
    groupSettlementAddInvoices: 'Add invoices',
    groupSettlementCancelAddInvoices: 'Cancel',
    groupSettlementStatus: {
      0: 'All',
      1: 'Pending',
      2: 'Active',
      3: 'Settled',
      4: 'Cancelled',
      5: 'Invalid'
    },
    invoiceError: 'Error',
    groupSettlementInvoicesShowTable: 'Show as table',
    groupSettlementInvoicesShowText: 'Show as text',
    groupSettlementInvoicesShowInput: 'Show as text input',
    badgeCancelled: 'Cancelled',
    badgeInvalid: 'Invalid',
    badgeSettled: 'Settled',
    createNew: 'Register new group settlement',
    groupSettlementRegister: 'Group settlement registration',
    invoiceList: 'Specification Invoice List',
    groupSettlementNumber: 'Group settlement number',
    settlementAmount: 'Amount',
    invoiceId: 'Invoice Id',
    groupSettlementSubmit: 'Create',
    groupSettlementConfirmation: 'Create new group settlement?',
    groupSettlementEdit: 'Edit',
    groupSettlementEditSave: 'Save',
    groupSettlementEditConfirmation: 'Edit group settlement specification',
    groupSettlementBack: 'Back',
    groupSettlementEditHeader: 'Edit group settlement',
    groupSettlementSingle: 'Group settlement specification',
    groupSettlementActivate: 'Activate',
    groupSettlementActivateTitle: 'Activate group settlement specification',
    groupSettlementActivateTitleDisabled: 'Can\'t activate a group settlement with invalid invoices',
    groupSettlementDeactivate: 'Deactivate',
    groupSettlementDeactivateTitle: 'Deactivate group settlement specification',
    groupSettlementCancel: 'Cancel',
    groupSettlementCancelTitle: 'Cancel group settlement specification',
    groupSettlementActivationConfirmation: 'Activate group settlement?',
    groupSettlementDeactivationConfirmation: 'Deactivate the group settlement specification',
    groupSettlementCancelationConfirmation: 'Cancel group settlement?',
    groupSettlementActivated: 'Group settlement activated',
    groupSettlementDeactivated: 'Group settlement specification deactivated',
    groupSettlementCanceled: 'Group settlement canceled',
    groupSettlementEdited: 'Group specification activated',
    groupSettlementNoEdit: 'You can not edit an already active or canceled group settlement',
    massInput: 'Invoices with amounts',
    massAdditionalInput: 'Invoices to be added to the group settlement specification',
    invoiceTableHeader: 'Invoices in group settlement specification',
    review: 'Review',
    groupSettlementRegistered: 'Group settlement successfully registered',
    massInputError: {
      tableHeader: 'List of validation errors',
      emptyOrTooFew: 'Group settlement specification has to contain at least two (2) invoices',
      malformedLine: 'Line: {0}, Invalid line',
      nonNumberAmount: 'Line: {0}, amount has to a be a number',
      duplicateInvoice: 'Line: {0}, Invoice is already in the list',
      returnedCodePrefix: 'Invoice error {0}:'
    },
    groupSettlementFetchingData: 'Fetching data from the server',
    groupSettlementFetchingDataFailed: 'There was an error while fetching group settlement specification, please try again later',
    groupSettlementRemoveInvoiceConfirmation: 'Are you sure you want to remove selected invoices from group settlement specification?',
    groupSettlementAddInvoiceConfirmation: 'Are you sure you want to add invocies to the group settlement specification',
    groupSettlementRemoveInvoice: 'Remove selected invoices',
    groupSettlementAddInvoice: 'Add invoices',
    selectInvalidInvoices: 'Select all invalid invoices',
    groupSettlementInvalidBanner: 'Group settlement specification is not valid. Change specification to be able to remove all canceled, settled or assigned invoices.',
    groupSettlementActivateLink: 'Activation information'
  },
  userAdministration: {
    userProfile: 'User profile',
    administration: 'Administration',
    localAdministration: 'Local administrator',
    userDetails: 'User details',
    userDetailsChange: 'User details change',
    userCreate: 'Create new user',
    userNotification: 'Create notification',
    userNotificationCancel: 'Cancel notification',
    details: 'Detals',
    userId: 'User ID',
    userLogin: 'User login',
    userOrganizationName: 'Organization name',
    userName: 'Name',
    userEmail: 'Email',
    userRoles: 'User roles',
    userRoleDescription: 'User role description',
    userClaims: 'User claims',
    userRolesClaims: 'User roles and claims',
    userStatus: 'Status',
    changePassword: 'Change password',
    oldPassword: 'Old password',
    newPassword: 'New password',
    confirmNewPassword: 'Confirm new password',
    password: 'Password',
    confirmPassword: 'Confirm password',
    confirmPasswordFail: 'Passwords don\'t match',
    passwordChanged: 'Password changed',
    userChangedId: 'Canceled by a user',
    userLastChangeDate: 'Cancelation date',
    userChangedComments: 'Cancelation comment',
    personalInformationChange: 'Change personal data',
    personalInformationChangeConfirmation: 'Change user data?',
    registrationInformationChangeConfirmation: 'Change registration data?',
    apply: 'Apply',
    userRevoke: 'Revoke',
    userRevokeComments: 'Reason for revoking',
    userRevokeConfirmation: 'Revoke user?',
    userPermissionUpdateConfirmation: 'Update user permissions?',
    userActivate: 'Activate',
    userActivateConfirmation: 'Are you sure you want to activate user?',
    userActiveStatus: 'Active',
    userRevokedStatus: 'Revoked',
    userRevoked: 'User successfully revoked',
    userRestored: 'User successfully restored',
    userPermissionsUpdated: 'User permissions updated',
    userRevokeFailed: 'User revoke failed',
    userRestoreFailed: 'User restore failed',
    userPermissionsUpdateFailed: 'User permission update failed',
    userPermissionsTableFilter: 'Filter',
    userPermissionsTableFilterClear: 'Clear',
    userCreateConfirmation: 'Create new local user?',
    userCreated: 'New user successfully created',
    userUpdated: 'User information updated',
    registrationUpdated: 'Registration information updated',
    notificationId: 'Notification ID',
    notificationCreator: 'Created by',
    notificationText: 'Notification text',
    notificationPriority: 'Priority',
    notificationPriorityStatus: {
      0: 'All',
      1: 'Low priority',
      2: 'Normal priority',
      3: 'High priority'
    },
    notificationValidUntil: 'Valid until',
    notificationCreatedDate: 'Creation date',
    notificationCreate: 'Create notification',
    notificationEdit: 'Edit notification',
    notificationCreated: 'Notification successfully created',
    notificationUpdated: 'Notification successfully updated',
    notificationFailed: 'Notification failed',
    Claim_Admin: 'Administration',
    Claim_User_Create: 'User create',
    Claim_User_Review: 'User review',
    Claim_User_Revoke: 'User revoke',
    Claim_Local_User_Create: 'Local user create',
    Claim_Local_User_Review: 'Local user review',
    Claim_Local_User_Revoke: 'Local user revoke',
    Claim_Invoice_Create: 'Invoice create',
    Claim_Invoice_Cancel: 'Invoice cancel',
    Claim_Invoice_Cancel_All: 'Cancel all invoices',
    Claim_Invoice_Review: 'Invoice review',
    Claim_Invoice_Review_All: 'View all invoices',
    Claim_Invoice_Export: 'Invoice export',
    Claim_Invoice_Settle: 'Invoice settle',
    Claim_Invoice_Assign: 'Invoice assign',
    Claim_Notification_Create: 'Notification create',
    Claim_Registration_Edit: 'Registration change',
    Claim_Invoice_Amount_Change: 'Invoice amount change',
    Claim_Invoice_Activate: 'Change settled invoice amount (multiple)',
    Claim_Invoice_Activate_Once: 'Invoice amount change',
    Claim_Issue_Resolve: 'Close the issue',
    Claim_Group_Settlement_Create: 'Creating group settlement',
    Role_Administrator: 'Administrator',
    Role_Operator: 'Treasury operator',
    Role_Local_Administrator: 'Local administrator',
    Role_Local_User: 'Local user',
    Role_Control: 'Inspection control',
    Role_Jafin_User: 'JAFIN user',
    entityStatuses: {
      0: 'Active',
      3: 'Temporarily inactive',
      9: 'Canceled'
    },
    userStatuses: {
      0: 'All',
      1: 'Active',
      2: 'Inactive',
      3: 'Revoked',
      4: 'Disabled'
    },
    userPasswordRequirement: {
      0: 'Password must contain at least 8 characters',
      1: 'Password must contain numbers',
      2: 'Password must contain uppercase letters',
      3: 'Password must contain symbols'
    },
    userLoginRequirement: {
      0: 'Login can contain latin letters',
      1: 'Login can contain numbers',
      2: 'Login can contain characters \'.\', \'_\' ',
      3: 'Login must start and end with letters or numbers',
      4: 'Login can contain 32 characters'
    },
    ungroupedClaims: 'Ungrouped claims',
    Role_Administrator_Description: 'Administration role description',
    Role_Operator_Description: 'Operator role description',
    Role_Local_Administrator_Description: 'Local administrator role description',
    Role_Local_User_Description: 'Local user role description',
    Role_Control_Description: 'Control user role description',
    Ungrouped_Description: 'Ungrouped claims description'
  },
  userRegistration: {
    registrationHeader: 'Institution registration',
    registrationInstitution: 'Institution information',
    registrationId: 'ID',
    registrationBudgetId: 'Budget ID',
    registrationCompanyNumber: 'Company number',
    registrationCompanyNumberShort: 'CRN',
    registrationTaxIdNumber: 'Tax ID number',
    registrationParentInstitution: 'Parent institution',
    registrationName: 'Name',
    registrationShortName: 'Short Name',
    registrationEmail: 'Email',
    registrationEntityType: 'Budget user type',
    registrationActivity: 'Activity',
    registrationCouncil: 'Council',
    registrationDirectBudgetCode: 'Direct budget code',
    registrationPhoneNumber: 'Phone number',
    registrationPostOfficeNumber: 'Post office number',
    registrationAddress: 'Address',
    registrationAdmin: 'Admin information',
    registrationAdminName: 'Admin name',
    registrationAdminIdentityNumber: 'Admin identity number',
    registrationAdminPersonalIdentityNumber: 'Admin personal identity number',
    registrationAdminEmail: 'Email',
    registrationAdminPhoneNumber: 'Phone number',
    registrationCreationDate: 'Registration request date',
    registrationRegistrationDate: 'Registration date',
    registrationRegistered: 'Registered',
    registrationAdminActivate: 'Administrator account activation',
    registrationApproved: 'Registration approved',
    registrationCancelled: 'Registration cancelled',
    registrationActivate: 'Activate account',
    registrationCancel: 'Cancel account',
    registrationStatus: 'Status',
    registrationStatuses: {
      0: 'All',
      1: 'Pending',
      2: 'Approved',
      3: 'Cancelled'
    },
    registrationApprovedUser: 'Registration approved by',
    registrationCancelledUser: 'Registration cancelled by',
    registrationApprovalDate: 'Approval date',
    registrationCancelConfirmationText: 'Cancel registration?',
    registrationApproveConfirmationText: 'Approve registration?',
    registrationFormTitle: 'User account registration form',
    adminFormTitle: 'Admin account form',
    registrationApprovedDate: 'Registration approved',
    invoiceLimitChangeText: 'Monthly limit for invoice registration',
    noInvoiceLimitText: 'No limit',
    invoiceLimitChangedText: 'Monthly limit for number of invoices registrations sucesfully changed'
  },
  datatable: {
    toggleAll: 'Toggle all',
    filter: 'Filter',
    perPage: 'Per page',
    range: 'Showing {0} to {1} of {2} entries',
    noData: 'No data',
    generateReport: 'Generate report',
    generateReportModalText: 'Generate report?'
  },
  message: {
    title: 'Invoice Registry',
    welcome: 'Welcome',
    login: 'Login',
    documentation: 'Documentation',
    signout: 'Signout',
    profile: 'Profile',
    externalLinks: 'External links'
  },
  apiStatusCodes: {
    0: 'Connection not available',
    400: 'Failed to process request',
    401: 'An error occured during user authorization',
    403: 'No valid authorized claim found',
    404: 'Endpoint not found',
    429: 'Endpoint request limit reached',
    500: 'An error occured during the usage of the service, please contact tehnical support',
    1001: 'Budget ID number is not valid',
    1002: 'Таџ ID number is not valid',
    1003: 'Company number is not valid',
    1004: 'Parent Tax ID number is not valid',
    1005: 'Parent company number is not valid',
    1006: 'Company name is not valid',
    1007: 'Company address is not valid',
    1008: 'Company phone number is not valid',
    1009: 'Company email is not valid',
    1010: 'Treasury branch is not valid',
    1011: 'Administrator name is not valid',
    1012: 'Administrator personal identity number is not valid',
    1013: 'Administrator identity number is not valid',
    1014: 'Administrator email is not valid',
    1015: 'Administrator phone number is not valid',
    1016: 'Inovoice number is not valid',
    1017: 'Amount is not valid',
    1018: 'Issue date is not valid',
    1019: 'Comments is not valid',
    1025: 'Data for monthly limit for number of registered invoices is invalid',
    1101: 'User login is not valid',
    1102: 'User name is not valid',
    1103: 'User email is not valid',
    1104: 'User password is not valid',
    1105: 'User password bad criteria',
    1107: 'Cancellation comment is not valid',
    1200: 'Invoice is not valid',
    1201: 'Invoice number is not valid',
    1202: 'Invoice amount is not valid',
    1203: 'Issue date is not valid',
    1204: 'Comment is not valid',
    1205: 'Budget number ID is not valid',
    1206: 'Issue place is not valid',
    1207: 'Invoice ID is not valid',
    1208: 'Cancel comments is not valid',
    1209: 'Number of invoices exceeds the limit',
    1210: 'Budget number ID is not valid',
    1211: 'Assignment contract number is not valid',
    1212: 'Lifetime not valid or too short',
    1300: 'Settlements is not valid',
    1301: 'Bank code is not valid',
    1302: 'Creditor Tax ID number is not valid',
    1303: 'Creditor company number is not valid',
    1304: 'Settled amount is not valid',
    1305: 'Debtor company number is not valid',
    1306: 'Invoice number is not valid',
    1308: 'Settlement comments are not valid',
    1400: 'Notification is not valid',
    1401: 'Priority is not valid',
    1402: 'Valid until date is not valid',
    1403: 'Notification text is not valid',
    1404: 'Notification status is not valid',
    1501: 'Requested per page number not valid',
    1601: 'Invoice id is not valid',
    1602: 'Change amount is not valid',
    1603: 'Change comment not valid or contains non valid symbols',
    1604: 'Change ID is not valid',
    1605: 'Change cancellation comment is not valid or contains non valid symbols',
    1701: 'CIR resource is not valid',
    1702: 'Resource ID is not valid',
    1703: 'Issue category is not valid',
    1704: 'Additional information about the issue is not valid',
    1705: 'Issue comment is not valid',
    1707: 'Operator comment is not valid',
    1802: 'Group settlement number contains non valid characters',
    2001: 'Registration request body empty',
    2002: 'Public entity not valid',
    2003: 'Legal entity not valid',
    2004: 'Registration request already submited',
    2005: 'Failed to send confirmation email',
    2008: 'Treasury branch not valid',
    2009: 'Missing registration ID for cancellation',
    2011: 'Legal information for budget user are not matching',
    2012: 'Registration token contains invalid data',
    2013: 'Registration is already approved or cancelled',
    2014: 'Attempting to register budget user without ID',
    2901: 'Unknown error trying to retrieve registration data',
    3000: 'Cir user not found',
    3001: 'Invalid password for Cir user',
    3002: 'Token for Cir user is invalid or revoked',
    3003: 'Refresh token for Cir user not found',
    3006: 'User is not currently marked as active',
    3007: 'User has been revoked',
    3008: 'Password length is invalid',
    3009: 'Password must contain numbers',
    3010: 'Password must contain uppercase letters',
    3011: 'Password must contain symbols',
    3012: 'User has been disabled',
    3014: 'Failed login attempts limit reached, please wait',
    3015: 'Invalid user or the user belongs to a wrong organisation',
    3900: 'Unknown error trying to create Cir access token',
    3901: 'Unknown error trying to obtain Cir refresh token',
    3902: 'Unknown error trying to retrieve Cir user',
    4000: 'Valid registration information not found for user',
    4003: 'User is not registered',
    4006: 'Failed to retrieve valid activation token',
    4007: 'User is already active',
    4009: 'Create new user failed',
    4011: 'User is not active',
    4012: 'User inactive or user status change failed',
    4013: 'Invalid permission submitted',
    4017: 'Status self-assign is not allowed',
    4018: 'Cannot update administrative permissions',
    4019: 'Cannot create user without privileges',
    4020: 'Activation of disabled user not allowed',
    4021: 'User information change failed',
    4022: 'Notification priority is not valid',
    4023: 'Notification status is not valid',
    4906: 'Error activating user, please try again',
    4912: 'Unknown error trying to edit user data',
    4905: 'Failed to approve user',
    4915: 'User type Operator is not allowed for the organization',
    4916: 'User claim for type Operator is not allowed for the organization',
    6001: 'Invoice liability validation failed',
    6002: 'Multiple invoice registration failure',
    6003: 'No valid invoices foud',
    6006: 'Invoice is already settled',
    6010: 'Invoice not active or is partially/fully settled',
    6011: 'Invoice has been cancelled',
    6013: 'Multiple invoice registration limit exceeded',
    6018: 'Settled amount tolerance exceeded',
    6019: 'Invoice number must not be empty',
    6020: 'Invoice number has invalid first character',
    6021: 'Invoice number has invalid last character',
    6023: 'Cannot assign already assigned liability',
    6024: 'Attempting to assign liability for invalid debtor',
    6025: 'Cannot re-assign already assigned liability',
    6027: 'Invoice liability assign not cancelled',
    6028: 'Cannot settle already assigned liability',
    6029: 'Invoice number has invalid character',
    6030: 'Registering invoice to self is not permitted',
    6032: 'Invoice number too long - allowed 22 characters',
    6033: 'Budget number not valid or budget user not active',
    6034: 'Budget number cannot be debtor',
    6039: 'Invoice amount change exceedes the invoice settled amount',
    6041: 'Invoice amount change is allowed only to the creditor of the invoice',
    6042: 'You can not assign an invoice to yourself',
    6043: 'Invoice amount can not be be zero after a change',
    6044: 'Budget user number belongs to the user that can not be a debtor',
    6046: 'No valid information found about invoice cancelation',
    6047: 'No valid information \\found about the user that cancelled the invoice',
    6055: 'Issue category does not belong to selected CIR resource',
    6056: 'Selected issue category requiers additional data',
    6057: 'No valid issue found',
    6060: 'Issue is not active or does not belong to an organization',
    6067: 'No valid group settlements found',
    6068: 'Group settlement number empty',
    6069: 'Group settlement number has invalid first character',
    6070: 'Group settlement number has invalid last character',
    6071: 'Group settlement number contains invalid characters',
    6072: 'Group settlement number has invalid length',
    6073: 'Invoice group settlement create request body empty',
    6074: 'Invalid group settlement invoice specification',
    6075: 'Repeated invoices found in specification',
    6076: 'No valid group settlements persisted',
    6077: 'Group settlement invoice specification empty',
    6078: 'No valid group settlement items found',
    6079: 'No valid group settlements updated',
    6080: 'Group settlement specification is cancelled',
    6081: 'Group settlement specification is settled',
    6082: 'Invoice group settlement get request body empty',
    6083: 'Invoice group settlement status change request body empty',
    6084: 'Invalid creditor for group settlement invoice specification',
    6085: 'Invalid amount for group settlement invoice specification',
    6086: 'Invalid group settlement item',
    6087: 'Invalid group settlement status',
    6088: 'Group settlement specification is invalid',
    6089: 'Invoice invalid amount found in specification',
    6090: 'Group settlement specification is active',
    6091: 'Group settlement specification contains one invoice',
    6092: 'Invoice settled amout changed for specified group settlement specification',
    6093: 'Invoice amount is changed for group settlement specification',
    6094: 'Invocie status is changed for the group settlement specification',
    6095: 'Unknown invoice or organization',
    6096: 'Invalid invoiceo debtor',
    6097: 'Maximum number of invoices for group settlement specification exceeded',
    6102: 'Proinvoice lifetime has to be in the future',
    6103: 'Lifetime has has to be between 1 and 90 days range',
    6106: 'Invoice is not registered inside of active group settlement specification',
    6108: 'Monthly limit for number of registered invoices exceeded',
    6901: 'Unknown error trying to register invoice',
    6902: 'Unknown error trying to retrieve invoice',
    6904: 'Invoice cancellation unsuccesful or you are not the invoice creditor',
    6916: 'Unknown error while fetching group settlement specification',
    54100: 'Unable to approve registration',
    54200: 'Unable to update organization hierarchy',
    54300: 'User has already been approved on the system',
    54400: 'Unable to add approved user',
    54500: 'User is already active',
    54600: 'Failed to insert new local user',
    54900: 'Attmpting to insert local user with illegal claims',
    55000: 'Local user count limit reached',
    55100: 'Changes to the user with higher privileges is not allowed',
    56000: 'Unknown error trying to register invoice',
    56100: 'Inserted Budget user ID not valid',
    56200: 'Invoice liabilities already submitted and registered',
    56700: 'Invoice liability already assigned',
    56900: 'Removing invoice assigned status failed',
    57000: 'Assigned invoice cancel failed',
    58200: 'You are not the invoice creditor or te invoice status does not allow changes to the invocie amount',
    58400: 'Amount change does not exist or is already cancelled',
    58500: 'Maximum number of invoice changes has been reached',
    58600: 'Maximum number of invoice activation has been reached',
    71300: 'Invoice or group settlement specification with the same data already registered'
  },
  errors: {
    someErrorsOccuredCheckListBelow: 'Some errors has occurred. Please check the list below',
    token: {
      refreshTokenExpired: 'Refresh token has expired',
      failedToRefreshToken: 'Failed to obtain new access token after refresh'
    }
  },
  autocomplete: {
    completeSedarchMessage: 'Enteret criteria \'{query}\' returns more than {limit} results.  Narrow down the search criteria or continue your search at {url}',
    urlText: 'to the list of budget users'
  },
  notifications: {
    apply: 'Apply',
    title: 'Notificatrions',
    subscribe: 'Subscribe to notifications',
    selectNotificationType: 'Select an event for wich you want to notified',
    subscribedIssueSuccessfully: 'You have successfully subscribed for notifications for the selected issue',
    unsubscribedIssueSuccessfully: 'You have successfully unsubscribed from notifications for the selected issue'
  },
  userSettings: {
    regionalHeader: 'Personal settings',
    regionalSubheader: 'Regional and localization settings',
    dateFormat: 'Date format',
    dateLocalization: 'Date localization',
    decimalFormat: 'Decimal format',
    csvSeparator: '\'CSV\' separator',
    language: 'Language',
    settingsSavedSuccess: 'Regional settings sucesfully changed',
    settingsSavedFail: 'An error occured while trying to save regional settings'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en.js